import type { ReactNode } from 'react';
import type { ReadState } from '../../lib/reads.ts';
import { linkClass } from './controls.tsx';
import { Notice } from './shell.tsx';

export function Read<T>({
  state,
  refresh,
  children,
}: {
  state: ReadState<T>;
  refresh: () => void;
  children: (data: T) => ReactNode;
}) {
  return state.status === 'ok' ? children(state.data) : <Pending state={state} refresh={refresh} />;
}

export function Pending({ state, refresh }: { state: ReadState<unknown>; refresh: () => void }) {
  if (state.status === 'loading') return <p className="text-xs text-ink-faint">Loading…</p>;
  if (state.status === 'error') return <Failed message={state.message} onRetry={refresh} />;
  return null;
}

export function Failed({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <Notice>
      {message}{' '}
      <button type="button" className={linkClass()} onClick={onRetry}>
        try again
      </button>
    </Notice>
  );
}
